type CurrentUser = {
  tenant?: { serviceTicketsEnabled?: boolean }
}

type Transition = {
  to: () => { name?: string }
  router: { stateService: { target: (state: string) => any } }
}

export const SERVICE_TICKET_STATES = ['root.tickets', 'root.ticketsDeleted', 'root.ticket', 'root.ticketEstimate']

const FALLBACK_STATE = 'root.projects'

// Service Tickets is being sunset. Hiding the nav entry still leaves these URLs typeable, so a
// tenant created after the cutoff is sent to the projects list instead. Defaults to allowing the
// route when the flag is missing, so a failed user load never strands a legacy tenant.
export const resolveServiceTicketsTransition = (trans: Transition, getCurrentUser: () => Promise<CurrentUser | null>) => {
  const toState = trans.to().name
  if (!toState || !SERVICE_TICKET_STATES.includes(toState)) {
    return undefined
  }
  return getCurrentUser().then((user) => {
    if (user?.tenant?.serviceTicketsEnabled === false) {
      return trans.router.stateService.target(FALLBACK_STATE)
    }
    return true
  })
}
